import { useTranslation as useI18nextTranslation } from 'react-i18next'
import { zh } from '@/i18n/locales/zh'
import { en } from '@/i18n/locales/en'
import type { TranslationKeys } from '@/i18n/locales/zh'

// Create a typed version of useTranslation that provides nested object access
export function useTranslation() {
  const { t: originalT, i18n, ...rest } = useI18nextTranslation()
  
  // Get the full translation object for the current language
  const getTranslations = (): TranslationKeys => {
    // Always use the imported translations for reliability
    const translations = i18n.language === 'en' ? en : zh
    return translations
  }
  
  // Create a t function that works like the original but also provides nested access
  const translations = getTranslations()
  const t = Object.assign(
    (key: string) => {
      // Try original t function first, then fallback to nested access
      const result = originalT(key)
      if (result !== key) return result
      
      // Fallback: manually navigate the nested object
      const keys = key.split('.')
      let value: any = translations
      for (const k of keys) {
        if (value && typeof value === 'object') {
          value = value[k]
        } else {
          return key
        }
      }
      return value || key
    },
    translations
  )
  
  return {
    t: t as TranslationKeys & ((key: string) => string),
    i18n,
    ...rest
  }
}